import { Link } from "react-router-dom";
import { HeartPulse } from "lucide-react";

const LINKS = [
  { to: null, href: "mailto:support@mdviacare.com", label: "Contact Us", testId: "footer-link-contact" },
  { to: "/privacy", label: "Privacy Policy", testId: "footer-link-privacy" },
  { to: "/terms", label: "Terms & Conditions", testId: "footer-link-terms" },
  { to: "/refund-policy", label: "Refund Policy", testId: "footer-link-refund" },
  { to: "/disclaimer", label: "Medical Disclaimer", testId: "footer-link-disclaimer" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="border-t border-slate-200 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-xl bg-[#1E5AA8] flex items-center justify-center"><HeartPulse className="w-4 h-4 text-amber-300" /></div>
            <span className="font-display font-bold text-[#123C73]">MDvia Care</span>
          </Link>
          <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm text-slate-500">
            {LINKS.map((l) =>
              l.to ? (
                <Link key={l.testId} data-testid={l.testId} to={l.to} className="hover:text-[#1E5AA8] transition-colors">{l.label}</Link>
              ) : (
                <a key={l.testId} data-testid={l.testId} href={l.href} className="hover:text-[#1E5AA8] transition-colors">{l.label}</a>
              )
            )}
          </nav>
        </div>
        <div className="mt-6 pt-6 border-t border-slate-100 text-center text-xs text-slate-400 leading-relaxed">
          © {year} MDvia Care · <a href="mailto:support@mdviacare.com" className="hover:text-[#1E5AA8]">support@mdviacare.com</a> · mdviacare.com
          <br />
          A clinical documentation tool for licensed doctors. MDvia Care is not a medical provider and does not offer medical advice.
        </div>
      </div>
    </footer>
  );
}
